import { useState } from "react";
import { Box, Button, Modal, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SelectInput from "../../Select/SelectInput";
import { companiesData } from "../../../utils/companies-data";
import { modalStyle } from "../../../utils/modal-style";

import "./CreateCityModal.scss";

export default function CreateCityModal({ id, open, setOpen }) {
  const accessToken = localStorage.getItem("token");
  const handleClose = () => setOpen(false);
  const [selectedUf, setSelectedUf] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    state: "",
    city: "",
    delivery_cost: "",
    km_idv: "",
    company: "",
  });

  async function handleChanges(e) {
    setFormValues((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="box-container-city" sx={modalStyle}>
        <form className="form-container-city">
          <h1>Cadastrar nova cidade</h1>
          <SelectInput
            value={selectedUf}
            name="UF"
            setValue={setSelectedUf}
            selectValues={[
              { id: 1, name: "GO" },
              { id: 2, name: "MG" },
              { id: 3, name: "SP" },
            ]}
          />

          <TextField
            label="Cidade"
            name="city"
            onChange={handleChanges}
            autoComplete="off"
          />

          <TextField
            label="Custo Entrega"
            name="delivery_cost"
            onChange={handleChanges}
            autoComplete="off"
          />

          <TextField
            label="km_idv"
            name="km_idv"
            onChange={handleChanges}
            autoComplete="off"
          />

          <SelectInput
            value={selectedCity}
            name="Selecione uma empresa"
            setValue={setSelectedCity}
            selectValues={companiesData}
          />

          <div className="buttons-container">
            <Button variant="contained">Sim</Button>
            <Button onClick={handleClose} variant="outlined">
              Não
            </Button>
          </div>
        </form>
      </Box>
    </Modal>
  );
}
